/**
 * URLs de audio TTS para los ítems de listening del test de nivel.
 *
 * Se generan UNA sola vez con:
 *   backend-workers/scripts/generate-leveltest-audio.ts
 * y se pegan aquí el mapa { id: audioUrl } que imprime el script.
 *
 * Mientras un id no tenga URL, el ítem de listening se reproduce sin audio
 * (el reproductor muestra el estado deshabilitado). NO afecta a la lógica del
 * motor: el cálculo del nivel es idéntico con o sin audio.
 */
export const LEVEL_TEST_AUDIO_URLS: Record<string, string> = {
  'L-A1-01': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-A1-01.mp3',
  'L-A1-02': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-A1-02.mp3',
  'L-A1-03': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-A1-03.mp3',
  'L-A1-04': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-A1-04.mp3',
  'L-A1-05': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-A1-05.mp3',
  'L-A2-01': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-A2-01.mp3',
  'L-A2-02': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-A2-02.mp3',
  'L-A2-03': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-A2-03.mp3',
  'L-A2-04': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-A2-04.mp3',
  'L-A2-05': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-A2-05.mp3',
  'L-B1-01': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-B1-01.mp3',
  'L-B1-02': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-B1-02.mp3',
  'L-B1-03': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-B1-03.mp3',
  'L-B1-04': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-B1-04.mp3',
  'L-B1-05': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-B1-05.mp3',
  'L-B2-01': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-B2-01.mp3',
  'L-B2-02': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-B2-02.mp3',
  'L-B2-03': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-B2-03.mp3',
  'L-B2-04': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-B2-04.mp3',
  'L-B2-05': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-B2-05.mp3',
  'L-C1-01': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-C1-01.mp3',
  'L-C1-02': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-C1-02.mp3',
  'L-C1-03': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-C1-03.mp3',
  'L-C1-04': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-C1-04.mp3',
  'L-C1-05': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-C1-05.mp3',
  'L-C2-01': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-C2-01.mp3',
  'L-C2-02': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-C2-02.mp3',
  'L-C2-03': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-C2-03.mp3',
  'L-C2-04': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-C2-04.mp3',
  'L-C2-05': 'https://lab.knwy-tools.com/challenges/activity-leveltest-L-C2-05.mp3',
};
